import React from "react";
import { createRoot } from "react-dom/client";
import "virtual:design-tokens.css";
import "./tournaments.css";
import "@spikeeasy/review/review.css";
import { Shell } from "./Shell";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Shell />
  </React.StrictMode>,
);
if (import.meta.env.PROD && "serviceWorker" in navigator) {
  navigator.serviceWorker.register("/sw.js").catch(() => {
    /* Online scoring remains available if offline installation fails. */
  });
}
